<app-instance-info-section></app-instance-info-section>
<div class="main-wrapper">
    <div class="row">
        <div class="col-md-3">
            <div class="activity-pack-type-list">
                <div class="approval_title">
                    <h4>Activity Pack Types</h4>
                </div>
                <div class="approval_list">
                    <ul class="activity-pack-list" #activityPackList>
                        <li
                            *ngFor="let type of activityPackTypes"
                            id="{{ type.activityPackTypeId }}"
                            [ngClass]="selectedActivityPackType?.activityPackTypeId == type.activityPackTypeId ? 'visited' : ''"
                            (click)="loadWorkflow(type.activityPackTypeId)"
                        >
                            <a href="javascript:void(0)">{{ type.name }}</a>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
        <div class="col-md-9">
            <div class="approval_card_details">
                <div class="approval_card_titles">
                    <div class="row">
                        <div class="col-12">
                            <h4 *ngIf="!displayWorkflow">Configure Activity Pack Workflow</h4>
                            <h4 class="text-dark" *ngIf="displayWorkflow">{{ selectedActivityPackType.name }}</h4>
                        </div>
                    </div>
                </div>
                <div class="no-type d-flex align-items-center justify-content-center w-100" style="height: 50vh" *ngIf="!displayWorkflow">
                    <h4>To configure workflow, please select a activity pack to the left and continue</h4>
                </div>
                <div class="workFlow-flowchart d-flex justify-content-center" *ngIf="displayWorkflow">
                    <mat-vertical-stepper class="activity-workflow-start" [linear]="true" [disableRipple]="true"  #stepper>
                        <mat-step [completed]="true" >
                            <ng-template matStepLabel>
                                <div class="start-end">
                                    <h5>Start Activity</h5>
                                </div>
                            </ng-template>
                        </mat-step>
                        <mat-step [completed]="true">
                            <ng-template matStepLabel>
                                <div class="plus-button">
                                    <button mat-button (click)="addWorkFlowStatus(0)" class="btn btn-dark">
                                        <span class="text-white">+</span>
                                    </button>
                                </div>
                            </ng-template>
                        </mat-step>
                        <!-- This is the template of between the start activity to end activity -->
                        <div *ngIf="currentWorkflowSteps.length > 0; else empty_status_workflow">
                            <mat-step [completed]="true">
                                <ng-template matStepLabel>
                                    <div
                                        cdkDropList
                                        class="workflow-status-list"
                                        #statusFlow="cdkDropList"
                                        [cdkDropListData]="currentWorkflowSteps"
                                        (cdkDropListDropped)="drop($event)"
                                    >
                                        <div
                                            class="workflow-status-box d-flex justify-content-center"
                                            *ngFor="let workFlowStatus of currentWorkflowSteps; let i = index"
                                            cdkDrag
                                        >
                                            <!-- The placeholder for the dragged item everything is hidden -->
                                            <div class="step-template" *cdkDragPlaceholder>
                                                <div class="workflow-deatils">
                                                    <div class="drag-icon invisible" cdkDragHandle>
                                                        <svg width="24px" fill="currentColor" viewBox="0 0 24 24">
                                                            <path
                                                                d="M10 9h4V6h3l-5-5-5 5h3v3zm-1 1H6V7l-5 5 5 5v-3h3v-4zm14 2l-5-5v3h-3v4h3v3l5-5zm-9 3h-4v3H7l5 5 5-5h-3v-3z"
                                                            ></path>
                                                            <path d="M0 0h24v24H0z" fill="none"></path>
                                                        </svg>
                                                    </div>
                                                    <div class="status-name invisible">
                                                        <span>{{ workFlowStatus.activityPackTypeStatus.name }}</span>
                                                    </div>
                                                    <div class="drag_indicator invisible">
                                                        <div class="action-icons">
                                                            <div class="edit-icon1">
                                                                <mat-icon #tooltip="matTooltip" matTooltip="View"
                                                                    ><a href="javascript:void(0)">edit</a></mat-icon
                                                                >
                                                            </div>
                                                            <div class="delete-icon1">
                                                                <mat-icon #tooltip="matTooltip" matTooltip="Remove"
                                                                    ><a href="javascript:void(0)">delete</a></mat-icon
                                                                >
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="vertical-line"></div>
                                                <div class="plus-button">
                                                    <button mat-button (click)="addWorkFlowStatus(i + 1)" class="btn btn-dark">
                                                        <span class="text-white">+</span>
                                                    </button>
                                                </div>
                                                <div class="vertical-line"></div>
                                            </div>
                                            <!-- This is the template of the dragged item-->
                                            <div *cdkDragPreview>
                                                <div class="workflow-deatils">
                                                    <div class="drag-icon" cdkDragHandle>
                                                        <svg width="24px" fill="currentColor" viewBox="0 0 24 24">
                                                            <path
                                                                d="M10 9h4V6h3l-5-5-5 5h3v3zm-1 1H6V7l-5 5 5 5v-3h3v-4zm14 2l-5-5v3h-3v4h3v3l5-5zm-9 3h-4v3H7l5 5 5-5h-3v-3z"
                                                            ></path>
                                                            <path d="M0 0h24v24H0z" fill="none"></path>
                                                        </svg>
                                                    </div>
                                                    <div class="status-name text-dark">
                                                        <span>{{ workFlowStatus.activityPackTypeStatus.name }}</span>
                                                    </div>
                                                    <div class="drag_indicator">
                                                        <div class="action-icons">
                                                            <div class="edit-icon1">
                                                                <mat-icon #tooltip="matTooltip" matTooltip="View"
                                                                    ><a href="javascript:void(0)">remove_red_eye</a></mat-icon
                                                                >
                                                            </div>
                                                            <div class="delete-icon1">
                                                                <mat-icon #tooltip="matTooltip" matTooltip="View"
                                                                    ><a href="javascript:void(0)">delete</a></mat-icon
                                                                >
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <!-- This is the template which is diplayed on UI-->
                                            <div class="step-template">
                                                <div class="workflow-deatils">
                                                    <div class="drag-icon" cdkDragHandle>
                                                        <svg width="24px" fill="currentColor" viewBox="0 0 24 24">
                                                            <path
                                                                d="M10 9h4V6h3l-5-5-5 5h3v3zm-1 1H6V7l-5 5 5 5v-3h3v-4zm14 2l-5-5v3h-3v4h3v3l5-5zm-9 3h-4v3H7l5 5 5-5h-3v-3z"
                                                            ></path>
                                                            <path d="M0 0h24v24H0z" fill="none"></path>
                                                        </svg>
                                                    </div>
                                                    <div class="status-name">
                                                        <span>{{ workFlowStatus.activityPackTypeStatus.name }}</span>
                                                    </div>
                                                    <div class="drag_indicator">
                                                        <div class="action-icons">
                                                            <div class="edit-icon1">
                                                                <mat-icon #tooltip="matTooltip" matTooltip="View" (click)="viewWorkFlowStatus(workFlowStatus)"
                                                                    ><a href="javascript:void(0)">remove_red_eye</a></mat-icon
                                                                >
                                                            </div>
                                                            <div class="delete-icon1">
                                                                <mat-icon
                                                                    #tooltip="matTooltip"
                                                                    matTooltip="Delete"
                                                                    (click)="deleteWorkflowStatus(workFlowStatus)"
                                                                    ><a href="javascript:void(0)">delete</a></mat-icon
                                                                >
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="vertical-line"></div>
                                                <div class="plus-button">
                                                    <button mat-button (click)="addWorkFlowStatus(i + 1)" class="btn btn-dark">
                                                        <span class="text-white">+</span>
                                                    </button>
                                                </div>
                                                <div class="vertical-line vertical-arrow"></div>
                                            </div>
                                        </div>
                                    </div>
                                </ng-template>
                            </mat-step>
                        </div>
                        <ng-template #empty_status_workflow> </ng-template>
                        <mat-step [completed]="true">
                            <ng-template matStepLabel>
                                <div class="start-end">
                                    <div *ngIf="true" >
                                        <h5>End Activity</h5>
                                    </div>
                                </div>
                            </ng-template>
                        </mat-step>
                    </mat-vertical-stepper>
                </div>
            </div>
        </div>
    </div>
</div>
 